import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  MaintenanceSolicitationData,
  MaintenanceSolicitationResponse,
} from '@/common/types/maintenance/maintenanceSolicitation'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useMaintenanceSolicitation: (id: string) => UseQueryResult<MaintenanceSolicitationData, unknown> = (
  id,
) => {
  const privateAxios = usePrivateAxios()

  return useQuery<MaintenanceSolicitationResponse, unknown, MaintenanceSolicitationData>({
    queryKey: ['maintenanceSolicitation', id],
    queryFn: () => privateAxios.get(`/maintenance/solicitations/${id}`),
    select: (data) => data?.data?.data,
  })
}
